<template>
  <div
    v-if="successMessage"
    class="alert alert-success alert-dismissible"
  >
    <b-link
      href="#"
      data-dismiss="alert"
      aria-label="close"
      class="close"
    >
      &times;
    </b-link>

    <strong>{{ successMessage }}</strong>
  </div>
</template>

<script>
// @vuese
// Componente que muestra los mensajes de éxito de las peticiones
export default {
  name: 'Success',

  // @vuese
  props: {
    successMessage: {
      type: String,
      default: null,
    },
  },
  /*
        computed: {
            // @vuese
            hasSuccess: function() {
                return Object.keys(this.success).length > 0;
            }
        }
        */

};
</script>

<style scoped>
</style>
